import Module, { registerModuleClass } from '@sparta.global.utilities/sparta-module-utility/dist/es6.js';

const Handlebars = require('@sparta.global.vendors/handlebars');
const Template = Handlebars.template({"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return "";
},"useData":true});
const renderTemplate = function (data, options) {
  return Template(data, options);
};

// Import templates & helpers
var _moduleConfig = {
  "name": "@sparta.sb-credit-cards.modules/connect-with-us-fix",
  "version": "1.0.3",
  "id": "connectWithUsFix",
  "containerID": "sbCreditCardsConnectWithUsFix",
  "moduleName": "sb-credit-cards-connect-with-us-fix",
  "semantic": true,
  "superModule": false,
  "viewPort": ["small", "medium", "large"],
  "tag": "div",
  "nameSpace": "connect-with-us-fix",
  "data": {
    "init": "ConnectWithUsFixModuleJS",
    "options": {}
  },
  "moduleParams": [],
  "layout": "layout",
  "render": function (context) {
    return renderTemplate(context, {
      "helpers": {},
      "partials": {}
    });
  },
  "template": renderTemplate,
  "partials": {},
  "helpers": {},
  "dependencies": {
    "@sparta.global.utilities/sparta-module-utility": "^1.0.0",
    "@sparta.global.utilities/sparta-style-token-utility": "^1.0.0",
    "@sparta.sb-credit-cards.utilities/sb-credit-card-utility": "^1.0.0"
  },
  "stores": []
};

/**
 * @export
 * @class ConnectWithUsFixModuleJS
 * @extends {Module}
 */
class ConnectWithUsFixModuleJS extends Module {
  /**
   * constructor
   * @param {Object} options Module options
   * @param {Object} context Module context
   */
  constructor(options, context) {
    super({
      ...options,
      context,
      config: _moduleConfig
    });
    this.a = document.getElementsByClassName('connect-fix');
  }

  /**
   * init
   * @returns {void}
   */
  init() {
    this.addChevron();
    this.connectFix();
    this.bindEventListeners();
  }

  /**
   * bindEventListeners
   *
   * @description Binds the event listeners for the module
   * @returns {void}
   */
  bindEventListeners() {
    document.querySelector('.connect-fix-block').addEventListener('click', this.chevronToggle.bind(this));
  }

  /**
   * @return {void}
   */
  chevronToggle() {
    const chevron = document.querySelector('.connect-chevron');
    if (chevron) {
      chevron.classList.toggle('active');
    }
  }

  /**
   * addChevron
   * @returns {void}
   */
  addChevron() {
    // finding where the connect with us module is
    const element = document.querySelector('.connect-with-us-module');
    if (element) {
      // look for first block container
      const element2 = element.querySelector('.block-container');
      if (element2) {
        // find call us title
        const callUs = element2.querySelector('.title');
        // if it exists, change the innerHTML to include the chevron
        if (callUs) {
          callUs.insertAdjacentHTML('afterbegin', '<span class="connect-chevron"> </span>');
          const callUsTitle = callUs.querySelector('.title-link');
          if (callUsTitle) {
            callUsTitle.addEventListener('click', this.chevronToggle.bind(this));
            this.bindEventListeners();
          }
        }
      }
    }
  }

  /**
  * @returns {void}
  */
  connectFix() {
    const elementToChange = document.querySelector('.connect-fix');
    // removing hide element that doesn't go away
    elementToChange.classList.remove('hide');
    // hiding the phone numbers until its clicked for the first time
    // and the global component does the rest
    elementToChange.style.display = 'none';
  }
}
registerModuleClass({
  moduleClass: ConnectWithUsFixModuleJS,
  moduleConfig: _moduleConfig
});
const moduleConfig = _moduleConfig;

export { ConnectWithUsFixModuleJS as default, moduleConfig };
